var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.show)?_c('div',{staticClass:"status-message",class:[
      { show: _vm.show },
      _vm.status,
      _vm.additionalClass,
      { 'large-modal': _vm.isLargeModal },
    ]},[(_vm.isLargeModal)?_c('img',{attrs:{"src":require("@/assets/images/doodles/modal-success.jpg"),"alt":"Modal Success"}}):_vm._e(),(_vm.isLargeModal && _vm.title)?_c('h3',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.message))]),(_vm.isLargeModal)?_c('button',{staticClass:"btn btn-small btn-border btn-narrow",attrs:{"type":"button"},on:{"click":_vm.closeModal}},[_vm._v("Close this")]):_vm._e()]):_vm._e(),(_vm.show && _vm.isLargeModal)?_c('div',{staticClass:"bg-overlay show",on:{"click":_vm.closeModal}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }